export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'a5d8ac28-c49b-4054-ba34-87b764cd3d89';
export const MODAL_CLOSE_SEC = 2.5;
